import React from 'react'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

const FooterStyle = styled.footer`
  background-color: rgba(237, 194, 157, 0.5);
  font-size: 0.8em;
  padding: 1rem;
  text-align: center;
  display: flex;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;

  div {
    display: inherit;
    align-items: center;
    margin: auto;
    width: 50vw;
    flex-flow: column;
    @media only screen and (max-width: 768px) {
      width: 90vw;
    }
  }

  span {
    display: block;
  }
`
const SocialLink = styled.a`
  font-size: 1.5em;
  color: hsla(0, 0%, 0%, 0.8);
  text-decoration: none;
`

const ExternalLink = styled.a`
  text-decoration: none;
  color: #000;
`

function Footer({ social }) {
  const year = new Date().getFullYear()

  return (
    <FooterStyle>
      <div>
        <SocialLink
          href={`http://twitter.com/${social.twitter}`}
          aria-label="Twitter"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faTwitter} />
        </SocialLink>
        <span>Copyright © {year} Raizean Ltd. All rights reserved.</span>
        <span>
          Website built by{' '}
          <ExternalLink
            href="http://fludlyt.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>Fludlyt</strong>
          </ExternalLink>
        </span>
      </div>
    </FooterStyle>
  )
}

export default Footer
